import script from "./ImageUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUpload.vue?vue&type=style&index=0&id=10303856&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10303856"]])

export default __exports__